'use client';

import createIconSet from './createIconSet';
import font from './vendor/react-native-vector-icons/Fonts/SimpleLineIcons.ttf';
import glyphMap from './vendor/react-native-vector-icons/glyphmaps/SimpleLineIcons.json';

export default createIconSet(glyphMap, 'simple-line-icons', font);
